import React from 'react';
import { Text, RadioGroup, Radio } from 'rsuite';
import {
  LOCAL_CONTACT,
  PROPERTY_MANAGEMENT_OPTIONS,
} from '../../payment/constants';
import { ValueType } from 'rsuite/esm/Radio';
import FormFieldErrorIcon from '../FormFieldErrorIcon';

interface LocalContactRadioGroupProps {
  error?: string;
  isTenant?: boolean;
  isOwner?: boolean;
  isPropertyManager?: boolean;
  localContactVerbiage: string;
  onChange: (value: LOCAL_CONTACT) => void;
  propertyManager: PROPERTY_MANAGEMENT_OPTIONS;
  value: LOCAL_CONTACT;
}
const PM_LABEL = 'The Property Manager';
const OWNER_LABEL = 'The Owner';
const MYSELF_PM_LABEL = 'Myself (the Property Manager)';
const MYSELF_OWNER_LABEL = 'Myself (the Owner)';
const TENANT_LABEL = 'The Tenant';
const MYSELF_LABEL = 'Myself';
const SOMEONE_ELSE_LABEL = 'Someone else';

export const LocalContactRadioGroup = ({
  error,
  isOwner,
  isTenant,
  isPropertyManager,
  localContactVerbiage,
  onChange,
  propertyManager,
  value,
}: LocalContactRadioGroupProps) => {
  const handleChange = (value: ValueType) => {
    onChange(value as LOCAL_CONTACT);
  };

  return (
    <>
      <Text>
        Who is the {localContactVerbiage.toLowerCase()} for this property?{' '}
        {error && <FormFieldErrorIcon errorMessage={error} />}
      </Text>
      <RadioGroup
        name="owner-rep-radio-option-group"
        defaultValue={LOCAL_CONTACT.OWNER}
        value={value}
        onChange={handleChange}
      >
        {isOwner && (
          <Radio value={LOCAL_CONTACT.OWNER}>
            {isPropertyManager ? MYSELF_LABEL : MYSELF_OWNER_LABEL}
          </Radio>
        )}
        {isPropertyManager && !isOwner && (
          <Radio value={LOCAL_CONTACT.PROPERTY_MANAGER}>
            {MYSELF_PM_LABEL}
          </Radio>
        )}
        {!isOwner && <Radio value={LOCAL_CONTACT.OWNER}>{OWNER_LABEL}</Radio>}
        {((!isPropertyManager &&
          propertyManager !== PROPERTY_MANAGEMENT_OPTIONS.SELF_MANAGED) ||
          (isPropertyManager &&
            isOwner &&
            propertyManager ===
              PROPERTY_MANAGEMENT_OPTIONS.PROPERTY_MANAGER)) && (
          <Radio value={LOCAL_CONTACT.PROPERTY_MANAGER}>{PM_LABEL}</Radio>
        )}
        {isTenant && !isOwner && !isPropertyManager && (
          <Radio value={LOCAL_CONTACT.TENANT}>{TENANT_LABEL}</Radio>
        )}
        <Radio value={LOCAL_CONTACT.OTHER}>{SOMEONE_ELSE_LABEL}</Radio>
      </RadioGroup>
    </>
  );
};
